// extracted by mini-css-extract-plugin
module.exports = {"notes":"PhotosCard_notes__2eK4n","notesText":"PhotosCard_notesText__tR2nP"};